var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lang-btn",style:({ border: ("0.5vh solid " + _vm.color), color: _vm.color }),on:{"click":_vm.changeLanguage}},[_vm._v(" "+_vm._s(_vm.selectedLanguageLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }